import { render, staticRenderFns } from "./topCards.vue?vue&type=template&id=63490529&scoped=true"
import script from "./topCards.vue?vue&type=script&lang=js"
export * from "./topCards.vue?vue&type=script&lang=js"
import style0 from "./topCards.vue?vue&type=style&index=0&id=63490529&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63490529",
  null
  
)

export default component.exports